import React, { useState, useEffect } from 'react';
import { useIsAdmin, useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import User from 'components/modal/user';
import { Input } from 'components/ui/form';
import { UserService } from 'services';
import { ROLE } from 'helpers/constants';
import styles from './users.module.scss';

const DEFAULT_LIMIT = 20;

const Users = ({ history }) => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [searchQuery, setSearchQuery] = useState('');
  const [modal, setModal] = useState(false);
  const isAdmin = useIsAdmin();

  useEffect(() => {
    let cancelled = false;

    async function fetchUsers() {
      setLoading(true);
      const params = { page, limit };
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      const response = await new UserService({ setUser }).getUsers(params);
      setLoading(false);

      if (cancelled || !response) return;
      if (response.items != null) {
        setData(response.items);
        setCount(response.count ?? 0);
      }
    }

    fetchUsers();
    return () => { cancelled = true; };
  }, [reload, page, limit, searchQuery, setUser, setLoading]);

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const cells = [{
    name: 'ID',
    nowrap: true,
    renderField: 'id',
  }, {
    name: 'Название',
    renderField: 'name',
  }, {
    name: 'Роль',
    nowrap: true,
    onRender: ({ role: { code } }) => ROLE.toString(code),
  }, {
    name: 'Логин / УНП',
    nowrap: true,
    renderField: 'inn',
  }, {
    name: 'Телефон',
    renderField: 'phone',
  }, {
    name: 'Email',
    nowrap: true,
    renderField: 'email',
  }, {
    name: '',
    right: true,
    nowrap: true,
    onRender: ({ id }) => (
      <Actions
        data={[{
          name: 'edit',
          title: 'Открыть профиль',
          onClick: () => {
            history.push(`/profile/${id}`);
          },
        }]}
      />
    ),
  }];

  return (
    <>
      <div className={styles.menu}>
        <Menu onAdd={isAdmin ? onOpenModal : null} />
      </div>
      <div className={styles.search}>
        <Input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Поиск по названию, УНП, телефону, email"
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells}
          data={data}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      </div>
      {isAdmin && modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <User onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default Users;
